import { createActionWithCallbacks } from '@move-frontend/auth';
import { signUp } from '../../domain/use-cases/signUp';

export const signUpWithCallbacks = createActionWithCallbacks(signUp);
